import { createRouter, createWebHistory } from 'vue-router'
import { gsap } from 'gsap'

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home-view" */ '@/views/HomeView.vue'),
    meta: {
      title: 'Home'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about-view" */ '@/views/AboutView.vue'),
    meta: {
      title: 'About'
    }
  },
  {
    path: '/playground',
    name: 'playground',
    component: () => import(/* webpackChunkName: "playground-view" */ '@/views/PlaygroundView.vue'),
    meta: {
      title: 'Playground'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact-view" */ '@/views/ContactView.vue'),
    meta: {
      title: 'Contact'
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import(/* webpackChunkName: "playgrproductsound-view" */ '@/views/ProductsView.vue'),
    meta: {
      title: 'Products'
    }
  },
  {
    path: '/:title',
    name: 'page-view',
    props: true,
    component: () => import(/* webpackChunkName: "page-view" */ '@/views/PageView.vue'),
    meta: {
      title: 'Page'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

/**
 * Create page transition overlay
 */
let transitionOverlay = null

const createTransitionOverlay = () => {
  if (!transitionOverlay) {
    transitionOverlay = document.createElement('div')
    transitionOverlay.className = 'route-transition-overlay'
    transitionOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background-color: #000;
      z-index: 9998;
      pointer-events: none;
      transform: translateY(100%);
    `
    document.body.appendChild(transitionOverlay)
  }
  return transitionOverlay
}

/**
 * Global navigation guard to handle page transitions
 * @param {import('vue-router').RouteLocationNormalized} to
 * @param {import('vue-router').RouteLocationNormalized} from
 * @param {import('vue-router').NavigationGuardNext} next
 */
router.beforeEach((_to, from, next) => {
  try {
    // Skip transition on initial load
    if (!from.name) {
      next()
      return
    }

    const overlay = createTransitionOverlay()

    // Animate overlay sliding up
    gsap.to(overlay, {
      y: '0%',
      duration: 0.4,
      ease: 'power3.inOut',
      onComplete: () => {
        next()
      }
    })
  } catch (error) {
    console.error('Navigation error:', error)
    next(false)
  }
})

/**
 * After navigation, slide overlay back down
 */
router.afterEach(() => {
  if (transitionOverlay) {
    // Small delay to let new content start rendering
    setTimeout(() => {
      gsap.to(transitionOverlay, {
        y: '-100%',
        duration: 0.4,
        ease: 'power3.inOut'
      })
    }, 100)
  }
})

export default router